var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrag1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40005 4.2C5.73142 4.2 6.00005 3.93137 6.00005 3.6C6.00005 3.26863 5.73142 3 5.40005 3C5.06868 3 4.80005 3.26863 4.80005 3.6C4.80005 3.93137 5.06868 4.2 5.40005 4.2Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40005 8.6C5.73142 8.6 6.00005 8.33137 6.00005 8C6.00005 7.66863 5.73142 7.4 5.40005 7.4C5.06868 7.4 4.80005 7.66863 4.80005 8C4.80005 8.33137 5.06868 8.6 5.40005 8.6Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40005 13C5.73142 13 6.00005 12.7314 6.00005 12.4C6.00005 12.0686 5.73142 11.8 5.40005 11.8C5.06868 11.8 4.80005 12.0686 4.80005 12.4C4.80005 12.7314 5.06868 13 5.40005 13Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 4.2C10.9314 4.2 11.2 3.93137 11.2 3.6C11.2 3.26863 10.9314 3 10.6 3C10.2687 3 10 3.26863 10 3.6C10 3.93137 10.2687 4.2 10.6 4.2Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 8.6C10.9314 8.6 11.2 8.33137 11.2 8C11.2 7.66863 10.9314 7.4 10.6 7.4C10.2687 7.4 10 7.66863 10 8C10 8.33137 10.2687 8.6 10.6 8.6Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 13C10.9314 13 11.2 12.7314 11.2 12.4C11.2 12.0686 10.9314 11.8 10.6 11.8C10.2687 11.8 10 12.0686 10 12.4C10 12.7314 10.2687 13 10.6 13Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag1);
export default __webpack_public_path__ + "static/media/drag1.fe0fca326c9482620ffaa35247d99306.svg";
export { ForwardRef as ReactComponent };